const API = process.env.REACT_APP_BACKEND_URL;

const STORAGE_KEY = "tpl_admin_token";

export function getToken() {
  return localStorage.getItem(STORAGE_KEY);
}
export function setToken(t) {
  localStorage.setItem(STORAGE_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(STORAGE_KEY);
}

async function _json(res) {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || body.message || res.statusText);
  }
  return res.json();
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const tplApi = {
  /* ── auth ─────────────────────────────────────── */
  requestMagicLink: (email, tenantSlug) =>
    fetch(`${API}/api/template/auth/magic-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, tenant_slug: tenantSlug }),
    }).then(_json),

  verifyToken: (token) =>
    fetch(`${API}/api/template/auth/verify?token=${token}`).then(_json),

  getMe: () =>
    fetch(`${API}/api/template/auth/me`, { headers: authHeaders() }).then(_json),

  /* ── tenant ──────────────────────────────────── */
  getTenant: (slug) =>
    fetch(`${API}/api/template/tenants/${slug}`).then(_json),

  /* ── public content ──────────────────────────── */
  getPublicContent: (slug) =>
    fetch(`${API}/api/template/${slug}/content`).then(_json),

  /* ── admin content ───────────────────────────── */
  getAdminContent: (slug) =>
    fetch(`${API}/api/template/${slug}/admin/content`, { headers: authHeaders() }).then(_json),

  saveContent: (slug, module, contentJson, action) =>
    fetch(`${API}/api/template/${slug}/admin/content/${module}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify({ content_json: contentJson, action }),
    }).then(_json),
};
